import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { List, ListItemButton, ListItemText, Menu } from "@mui/material";
import { AngleIcon } from "../../../Icons";

const HeaderEvents = () => {
  const [headerMenuEl, setHeaderMenuEl] = useState(null);
  const headerMenuOpen = Boolean(headerMenuEl);
  const headerMenuOpenReq = (event) => {
    setHeaderMenuEl(event.currentTarget);
  };
  const headerMenuClose = () => {
    setHeaderMenuEl(null);
  };

  return (
    <React.Fragment>
      <div
        className={`managepro6ix-layout-header-bottom-menu-link ${
          headerMenuOpen ? "active" : ""
        }`}
        id="header-events-menu-button"
        aria-controls={headerMenuOpen ? "header-events-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={headerMenuOpen ? "true" : undefined}
        onClick={headerMenuOpenReq}
      >
        6ix Events
        {headerMenuOpen ? <AngleIcon up /> : <AngleIcon small />}
      </div>

      <Menu
        id="header-events-menu"
        anchorEl={headerMenuEl}
        open={headerMenuOpen}
        onClose={headerMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-events-menu-button",
        }}
        className="managepro6ix-layout-header-bottom-menu-link-dropdown managepro6ix-layout-header-bottom-menu-link-dropdown-users"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List
          component="nav"
          className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list"
        >
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Dashboard"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events/users"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Users"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events/organization"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Organizations"
            />
          </ListItemButton>

          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events/list"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Events"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events/transactions"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Transactions"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item"
            component={NavLink}
            to="/events/news"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-bottom-menu-link-dropdown-users-list-item-text"
              primary="Press Releases"
            />
          </ListItemButton>
        </List>
      </Menu>
    </React.Fragment>
  );
};

export default HeaderEvents;
